import GeneralTracker from '../GeneralTracker';


export default class FriendsAndFavoritesMenuTracker extends GeneralTracker {
  CAPTURE_NAME = 'ui:menus:friendsfavorites:usage';
  STORAGE_KEY = 'friendsAndFavoritesTrackingKey';
  VERSION = '1';

  setHandlers() {
    const service = this.getService();
    service.on('toggleFriendsAndFavoritesMenu', this.onToggle);
    service.on('selectTabFriendsAndFavoritesMenu', this.onSelectTab);
    service.on('clickOnBroadcasterInFriendsAndFavoritesMenu', this.onLinkClick);
    service.on('previewBroadcasterInFriendsAndFavoritesMenu', this.onPreviewToggle);
  }

  onToggle = (payload) => {
    const trackPayload = { action: payload.action };

    this.track(trackPayload);
  };

  onSelectTab = (payload) => {
    const trackPayload = {
      action: 'menuTabSelection',
      tag: { ...payload },
    };

    this.track(trackPayload);
  };

  onLinkClick = (payload) => {
    const trackPayload = {
      action: 'broadcasterLinkClick',
      tag: {
        broadcaster: { name: payload.user.username },
        avatar: { ...payload.avatar },
      },
    };

    this.track(trackPayload);
  };

  onPreviewToggle = (payload) => {
    const trackPayload = { action: `${payload.action}Preview` };

    this.track(trackPayload);
  };
}
